module.exports = __webpack_public_path__ + "img/P43-en.3a60bd0e.png";